export function gauge(ctx) {
    return {
        properties: {
            value_color: '#ffffff',
            value_font:  32,
        },
        styles: {
            main: {
                ...ctx.pretty,
                radius: 999,
                padding: 10,
                scale_width: 9,
                scale_border_width: 0,
                line_width: 3,
                line_color: '#ffffff',
                scale_grad_color: '#ffffff',
                scale_end_color: '#ffffff',
            },
            indicator: {
                bg_color: '#ffffff',
                radius: 999,
                border_width: 0,
                line_color: '#ffffff',
                line_width: 4,
            },
            major_ticks: {
                scale_width: 16,
                line_width: 4,
                line_color: '#888888',
                scale_grad_color: '#888888',
                scale_end_color: '#ffffff',
            },
        },
    };
}
